import { isLegacyImage } from "../native/legacy-import-image";
import { legacyLayers } from "../native/legacy-import-groups";
import { assertProjectDocument } from "../document/model";
import { importLegacyDocument } from "../native/legacy-import";
import { nativeImageSource } from "../native/image-formats";
import { clipboardSourceFile } from "./clipboard-source";
import { ImageStore, readImageFile } from "../render/image-store";
const placeholder =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQIHWP4z8DwHwAFgAI/ScLttAAAAABJRU5ErkJggg==";
function resourceUrl(source: string) {
  // The copy's own catalog resources also work in the isolated local preview.
  const url = new URL(source);
  if (
    url.origin === "https://3dcoverdesign.ru" &&
    url.pathname.startsWith(
      "/templates/boxed/controllers/creatorenginepro/assets/",
    )
  )
    return location.origin + url.pathname + url.search;
  return source;
}

/** Download once, preserve source bytes, and validate before any scene replacement. */
export async function prepareLegacyDocument(
  input: unknown,
  images: ImageStore,
) {
  assertProjectDocument(input);
  const sources = [
    ...new Set(
      input.screens.flatMap((s) =>
        legacyLayers(s.layers || [])
          .filter((l) => isLegacyImage(l.data))
          .map((l) => String(l.data.src || "")),
      ),
    ),
  ];
  importLegacyDocument(input, new Map(sources.map((s) => [s, placeholder])));
  const resolved = new Map<string, string>();
  // Bounded concurrency and total media budget, including embedded resources.
  let next = 0,
    bytes = 0;
  await Promise.all(
    Array.from({ length: Math.min(4, sources.length) }, async () => {
      while (next < sources.length) {
        const source = sources[next++]!;
        if (!nativeImageSource(source) && !/^https?:\/\//i.test(source))
          throw new Error("В старом проекте недоступный адрес изображения.");
        const data = nativeImageSource(source)
          ? source
          : await readImageFile(await clipboardSourceFile(resourceUrl(source)));
        bytes += data.length * 0.75;
        if (data.length > 34 * 1024 * 1024 || bytes > 128 * 1024 * 1024)
          throw new Error(
            "Изображения проекта превышают доступный размер импорта.",
          );
        resolved.set(source, data);
      }
    }),
  );
  const result = importLegacyDocument(input, resolved);
  await images.prepare(result.assets);
  for (const layer of legacyLayers(input.screens[0]!.layers || []))
    if (layer.data.type === "image") {
      const d = layer.data,
        image = images.get(resolved.get(String(d.src))!)!;
      if (d.width !== image.naturalWidth || d.height !== image.naturalHeight)
        throw new Error(
          "Импорт обрезанного исходника изображения пока не поддерживается. Текущий документ остаётся на холсте.",
        );
    }
  return result;
}
